import { Component, ViewEncapsulation, ViewChild, ElementRef, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-nav-header',
    template: `<ng-content></ng-content>`,
    styles: [
        `.cfa-nav-header {
                            filter: inherit !important;
                            overflow: hidden;
                            pointer-events: all;
                            -webkit-overflow-scrolling: touch;
                        }`
    ],
    encapsulation: ViewEncapsulation.None
})
// tslint:disable-next-line:component-class-suffix
export class CfaNavHeader {
    @ViewChild('cfaNavHeader') navHeader: ElementRef;

    @Output() bodyClicked: Subject<void> = new Subject();

    public getNavHeader() {
        if (this.navHeader) {
            return this.navHeader.nativeElement;
        }
    }

    clickBody() {
        this.bodyClicked.next();
    }
}
